import { isMacOs } from '../../../helpers/device';

const isMac = isMacOs();

const HOT_KEY_LABEL_GLOBAL_SEARCH = isMac ? '⌘+Shift+F' : 'Ctrl+Shift+F';
const HOT_KEY_LABEL_CHAT_SEARCH = isMac ? '⌘+F' : 'Ctrl+F';
// const HOT_KEY_LABEL_FAQ = isMac ? '⌘+/' : 'Ctrl+/';

const HOT_KEY_LABEL_FAQ = '';

// Хоткеи для микрофона и камеры
const HOT_KEY_LABEL_TOGGLE_MICRO = isMac ? '⌘+D' : 'Ctrl+D';
const HOT_KEY_LABEL_TOGGLE_CAMERA = isMac ? '⌘+E' : 'Ctrl+E';

export {
    HOT_KEY_LABEL_GLOBAL_SEARCH,
    HOT_KEY_LABEL_CHAT_SEARCH,
    HOT_KEY_LABEL_FAQ,
    HOT_KEY_LABEL_TOGGLE_MICRO,
    HOT_KEY_LABEL_TOGGLE_CAMERA,
};
